// Webpack チャンク読み込みエラーのハンドリング
// このファイルをmain.tsxでインポートして使用

export const handleChunkLoadError = () => {
  // Webpackのチャンク読み込みエラーをキャッチ
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason?.name === 'ChunkLoadError') {
      console.warn('Chunk load error detected, attempting page reload...', event.reason);
      
      // ユーザーに通知してページをリロード
      if (confirm('アプリケーションの更新を検出しました。ページを再読み込みしますか？')) {
        window.location.reload();
      }
      
      // エラーを抑制
      event.preventDefault();
    }
  });

  // WebpackのrunTimeエラーをキャッチ
  window.addEventListener('error', (event) => {
    if (event.message?.includes('Loading chunk')) {
      console.warn('Chunk loading error detected:', event);
      
      // 必要に応じてページリロード
      if (confirm('リソースの読み込みに失敗しました。ページを再読み込みしますか？')) {
        window.location.reload();
      }
    }
  });
};

// CSP エラーのハンドリング
export const handleCSPErrors = () => {
  window.addEventListener('securitypolicyviolation', (event) => {
    console.warn('CSP Violation:', event);
    
    // ブラウザ拡張機能によるCSP違反は無視
    if (event.sourceFile?.includes('chrome-extension://')) {
      console.log('Ignoring browser extension CSP violation');
      return;
    }
    
    // その他のCSP違反は記録
    console.error('Actual CSP violation that needs attention:', {
      directive: event.violatedDirective,
      blockedURI: event.blockedURI,
      sourceFile: event.sourceFile,
      lineNumber: event.lineNumber
    });
  });
};
